import styled from 'styled-components';

export const Heading = styled.div`
  ${Styles.mobileLandscape`
    padding-top: 20px;
  `}
`;
